import { useTranslation } from 'react-i18next'
import AlreadyRegisteredWrapper from 'app/auth/components/onboarding/steps/shared/AlreadyRegisteredWrapper'
import { useOnboardingContext } from 'app/auth/components/onboarding/use-onboarding-context'
import { Box, Typography } from '@mui/material'
import { useApplicationName } from 'hooks/use-application-name'

const AlreadyRegisteredMGID = () => {
  const { t } = useTranslation()
  const { duplicationData } = useOnboardingContext()
  const { appName } = useApplicationName()

  return (
    <AlreadyRegisteredWrapper>
      <Box my={2}>
        <Typography component='div' variant='body1' style={{ whiteSpace: 'pre-line' }}>
          {t('Auth.AlreadyRegisteredMessageMGID1', { appName, shopNumber: duplicationData?.dupe.ID })}
        </Typography>
      </Box>
      <Box my={2}>
        <Typography component='div' variant='body1' style={{ whiteSpace: 'pre-line' }}>
          {t('Auth.AlreadyRegisteredMessageMGID2')}
        </Typography>
      </Box>
    </AlreadyRegisteredWrapper>
  )
}

export default AlreadyRegisteredMGID
